import { SABox, SAColumns } from '@saux/design-system-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import claimSearch from '../../store/actions/claimsSearchActions';
import SearchSuggestion from '../searchSuggestion/SearchSuggestion';
import { isNotEmpty, simpleGTMDataLayer } from '../../utils/utilities';
import { useDispatch, useSelector } from 'react-redux';

import './SimpleSearch.css';
import fetchConversations, { fetchConversationById } from '../../store/actions/conversationActions';
import { SIMPLE_SEARCH } from '../../utils/constants';



export default function SimpleSearch(props: any) {

    const [claims, setClaims] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const user = useSelector((state: any) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: 'pageview',
            page: {
                path: '/search?advancedSearch=false',
                title: 'Claims Texting: Simple Search Page'
            }
        });
    }, [])

    useEffect(() => {
        if (isNotEmpty(searchQuery) && searchQuery.length >=3) {
            //Snowplow tag for Simple Search
            simpleGTMDataLayer({
                csrId: user.userName,
                event: `Contact-Search-Type-Click`,
                event_action: 'Button Click',
                event_category: window.location.pathname,
                event_label: `Selecting search type`,
                event_value: `${ SIMPLE_SEARCH}`
              });
              simpleGTMDataLayer({
                csrId: user.userName,
                event: `Contact-Search-Type-Click-Snowplow`,
                event_action: 'Button Click',
                event_category: window.location.pathname + "/Snowplow",
                event_label: `Selecting search type`,
                event_value: `${SIMPLE_SEARCH}`
              });

              //Snowplow tag to capture input details of Simple Search  
            simpleGTMDataLayer({
                csrId: user.userName,
                    event: `Search-Action-In-Simple-Search`,
                    event_action: 'Button Click',
                    event_category: window.location.pathname,
                    event_label: `This is for searching claims with given search value`,
                    event_value: `${user.fullName} has initiated simple search with search value: ${searchQuery}`
                });
                simpleGTMDataLayer({
                csrId: user.userName,
                    event: `Search-Action-In-Simple-Search-Snowplow`,
                    event_action: 'Button Click',
                    event_category: window.location.pathname + "/Snowplow",
                    event_label: `This is for searching claims with given search value`,
                    event_value: `${user.fullName} has initiated simple search with search value: ${searchQuery}`
                });
                
            claimSearch({ query: searchQuery })
                .then((res: any) => {
                    setClaims(res.data.searchClaims);
                })
                .catch(err => console.log(err))
        } else {
            setClaims([]);
        }
    }, [searchQuery]);

    const onClear = () => {
        let e = { currentTarget: { value: '' } }
        handleChange(e);
    }

    const handleSelect = (index: any) => {
        let selectedItem: any = claims[index];
        fetchConversationById({ claimNumber: selectedItem.claim_number, phoneNumber: selectedItem.claimant_phone_number }, user.email,
            (res: any) => {
                if (res && res.archiveStatus) {
                    dispatch(fetchConversations({ adjusterId: user?.email, isArchived: true },
                        (res)=>{
                            props.createConversation(selectedItem);
                        }));
                }
                else {
                    dispatch(fetchConversations({ adjusterId: user?.email, isArchived: false },
                        (res)=>{
                            props.createConversation(selectedItem);
                        }));
                }
            });
       // props.createConversation(selectedItem);
    }

    function handleChange(e: any) {
        console.log(`e |${e.currentTarget.value}|`);
        if (e.currentTarget && searchQuery !== e.currentTarget.value.trim()) {
            const query: string = e.currentTarget.value.trim();
            console.log(query)
            const values = query.split(' | ')
            console.log({ values })
            // if (values.length >= 4) {
            //     window.open("/profile/" + values[4], "_self");
            // }
            // setIsLoaded(false);
            setSearchQuery(query);
        }
    }

    const Highlighter = ({ children, highlight = searchQuery, className }: any) => {
        if (!highlight || !children) return children;
        if (typeof children === "object") {
            return children;
        }
        const regexp = new RegExp(highlight, 'gi');
        const matches = children.match(regexp);
        const parts = children.split(new RegExp(`${highlight.replace()}`, 'gi'));
        // TODO: refactor this, not a fan of the mutation of part
        for (let i = 0; i < parts.length; i++) {
            if (i !== parts.length - 1) {
                let match = matches[i];
                // While the next part is an empty string, merge the corresponding match with the current
                // match into a single <span/> to avoid consequent spans with nothing between them.
                while (parts[i + 1] === '') {
                    match += matches[++i] || '';
                }

                parts[i] = (
                    <React.Fragment key={i}>
                        {parts[i]}
                        <span className="highlighted">{match}</span>
                    </React.Fragment>
                );
            }
        }
        return <span className={`highlighter ${className}`}>{parts}</span>;
    };

    const getDropDownOptions = () => {
        return (claims || []).map((claim: any) => {
            return (
                <div className="search-dropdown-list" style={{ width: "100%" }}>
                    <SAColumns key={claim._id} columns={{ sm: [4, 4, 4], xs: [12, 12, 12] }}>
                        <div>
                            <SABox pb="small">
                                <span style={{ fontSize: 16 }}>
                                    <b>
                                        <Highlighter>
                                            {claim.first_name + " " + claim.last_name}
                                        </Highlighter>
                                    </b>
                                </span>
                            </SABox>
                            <SABox pb="small">
                                <b>Claim Number: </b>
                                <Highlighter>
                                    {claim.claim_number}
                                </Highlighter>
                            </SABox>
                            <SABox><b>Status:</b> {claim.claim_status}</SABox>
                        </div>

                        <div style={{ paddingLeft: 10 }}>
                            <SABox pb="small"><b>Address:</b> {claim.claimant_address}</SABox>
                            <SABox pb="small"><b>LOB:</b> {claim.lob}</SABox>
                            <SABox><b>Care Professional:</b> {claim.care_professional}</SABox>
                        </div>
                        <div style={{ paddingLeft: 10 }}>
                            <SABox pb="small"><b>Loss Date:</b> {moment(claim.loss_date || "").format(
                                "MM-DD-YYYY")}</SABox>
                            <SABox pb="small">
                                <b>Phone Number: </b>
                                <Highlighter>
                                    {claim.claimant_phone_number || "N/A"}
                                </Highlighter>
                            </SABox>
                            <SABox ><b>Zip Code:</b> {claim.zip}</SABox>
                        </div>
                    </SAColumns>
                </div>
            )
        })

    }

    function searchBar() {
        return (
            <SearchSuggestion
                id="userAutoComplete"
                options={getDropDownOptions()}
                onChange={handleChange}
                onSelect={handleSelect}
                onClear={onClear}
                placeholder="Search by name, claim number or contact number"
                // icon={SAIcons.search}
                {...{ fullWidth: true }}
            />
        );
    }


    return (
        <div data-testid="advanced-search" style={{ margin: 30, marginTop: 10 }}>
            {searchBar()}
        </div>
    )
}
